import {
    //Old site users
    OLD_USER_GET,
    OLD_USERS_GET,
    OLD_USER_POST,
    OLD_USER_PUT,
    OLD_USER_DELETE,
    USER_PROFILES_GET
} from "../../types";

import {getAPI, postAPI, putAPI, deleteAPI} from '../crud';
import {setLocal} from '../support';
import {localClearToken, postRefToken, setIntervalRef, setProfileNull} from "../default/default";

//Old site users
export function oldUserPost(_url, token, datas) {
    const data = {
        url: `${_url.domen}/api/${_url.version}/${setLocal(_url.local)}/old/user`,
        token: token,
        actionType: OLD_USER_POST,
        data: datas,
        header: {
            'Authorization': token,
            'Content-Type': 'application/json'
        }
    }
    return postAPI(data);
}

export function oldUserGet(_url, token) {
    const data = {
        url: `${_url.domen}/api/${_url.version}/${setLocal(_url.local)}/old/user/${_url.id}`,
        token: token,
        actionType: OLD_USER_GET,
        header: {
            'Authorization': token,
            'Content-Type': 'application/json'
        }
    }
    return getAPI(data);
}

export function oldUserPut(_url, token, datas) {
    const data = {
        url: `${_url.domen}/api/${_url.version}/${setLocal(_url.local)}/old/user/${_url.id}`,
        token: token,
        actionType: OLD_USER_PUT,
        data: datas,
        header: {
            'Authorization': token,
            'Content-Type': 'application/json'
        }
    }
    return putAPI(data);
}

export function oldUserDelete(_url, token) {
    const data = {
        url: `${_url.domen}/api/${_url.version}/${setLocal(_url.local)}/old/user/${_url.id}`,
        token: token,
        actionType: OLD_USER_DELETE,
        header: {
            'Authorization': token,
            'Content-Type': 'application/json'
        }
    }
    return deleteAPI(data);
}

export function oldUsersGet(_url, token) {
    const data = {
        url: `${_url.domen}/api/${_url.version}/${setLocal(_url.local)}/old/users${_url.params}`,
        token: token,
        actionType: OLD_USERS_GET,
        header: {
            'Authorization': token,
            'Content-Type': 'application/json'
        }
    }
    return getAPI(data);
}

export function userProfileGet(_url, token, props, isRecursive) {
    // const data = {
    //     url: `${process.env.REACT_APP_END_POINT_BD}/api/v1/uk/private/user/profile`,
    //     actionType: USER_PROFILES_GET,
    //     header: {
    //         'Authorization': token,
    //         'Content-Type': 'application/json'
    //     }
    // }
    // return getAPI(data);

    props = props ?? null
    isRecursive = isRecursive ?? false

    return async dispatch => {
        fetch(`${process.env.REACT_APP_END_POINT_BD}/api/v1/uk/private/user/profile`, {
            method: 'GET',
            headers: {
                'Authorization': token,
                'Content-Type': 'application/json'
            }
        }).catch(error => {
            //@todo some error message?
            console.error(error)
            // dispatch({type: 'TOKEN_CLEAR', payload: null})
        }).then(response => {
            if (response.status === 401) {
                if (isRecursive && typeof props?.token?.refresh_token !== 'undefined') {
                    //token refresh failed, clear storage
                    // dispatch({type: 'TOKEN_CLEAR', payload: null})
                    // dispatch({type: 'SET_PROFILE_NULL', payload: null})
                    dispatch(setProfileNull(null));
                    dispatch(localClearToken());
                    return
                } else {
                    //refresh auth token and try again:
                    if (props?.token?.refresh_token) {
                        const refresh = postRefToken(process.env.REACT_APP_END_POINT_BD, props?.token?.refresh_token)
                        refresh(dispatch)
                        return userProfileGet(_url, token, props, true)
                    }
                    dispatch(setProfileNull(null));
                    dispatch(localClearToken());
                    return
                }
            }
            response.json().then(parsedJson => {
                dispatch({type: USER_PROFILES_GET, payload: parsedJson})
            })
        })
    }
}